import {v4 as uuidV4} from "uuid";

export default class HttpData {
    public uuid: string;

    constructor() {
        this.uuid = uuidV4();
    }
}